module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "shop-order-detail-record",
    class: _vm.background()
  }, [_c('td', [_c('p', {
    staticClass: "img-area-list"
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePath
    }
  })]), _c('p', [_vm._v(_vm._s(_vm.shopOrderDetail.consumable_item_name))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.supplier_name))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.just_stock_number))])]), (_vm.isChangeStockQuantity) ? _c('td', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stockQuantity),
      expression: "stockQuantity"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.stockQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stockQuantity = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn margin-left",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "disabled": !_vm.shopOrderDetail.stock_quantity
    },
    on: {
      "click": function($event) {
        _vm.updateStockQuantity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('button', {
    staticClass: "btn margin-left",
    staticStyle: {
      "padding": "0px"
    },
    on: {
      "click": function($event) {
        _vm.resetStockQuantity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])])]) : _c('td', [_c('span', [_vm._v(_vm._s(_vm.stockQuantity))]), (_vm.isCanEdit) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.isChangeStockQuantity = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()]), (_vm.isChangeOrderLotQuantity) ? _c('td', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderLotQuantity),
      expression: "orderLotQuantity"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.orderLotQuantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderLotQuantity = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn margin-left",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "disabled": !_vm.shopOrderDetail.order_lot_quantity
    },
    on: {
      "click": function($event) {
        _vm.updateOrderLotQuantity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _c('button', {
    staticClass: "btn margin-left",
    staticStyle: {
      "padding": "0px"
    },
    on: {
      "click": function($event) {
        _vm.resetOrderLotQuantity()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])])]) : _c('td', [_c('span', [_vm._v(_vm._s(_vm.orderLotQuantity))]), (_vm.isCanEdit) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.isChangeOrderLotQuantity = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.formatedLotPrice))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.formatedSubTotalPrice))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.shop_hold_on_place_name))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.confirm_user_name))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.confirm_date_format))])]), _c('td', [_c('span', [_vm._v(_vm._s(_vm.shopOrderDetail.comment))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36757534!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shop-order-detail-record.pug
// module id = 794
// module chunks = 1